/**
 * Media Helper
 * Provides media query and viewport related helper functions
 *
 * @module Media
 * @author EN GARDE
 * @version 1
 *
 * note: IE <9 support should be handled automatically by responds.js
 * @link https://blacksaildivision.com/matchmedia
 */

const MediaHelper = ( function() {
	'use strict';

	// see assets/styles/settings/layout.scss
	var breakpoints = {
		small: 500,
		medium: 720,
		desktop: 980,
		large: 1600
	};

	/**
   * get Info on a breakpoint by name
   * @param  string breakpoint – the breakpoint name
   * @return number – width
   */
	var getBreakpoint = function( breakpoint ) {
		return breakpoints[breakpoint] || undefined;
	};

	/**
   * build the media query
   *
   * @param string lower – lower breakpoint name
   * @param string [upper] – upper breakpoint name (optional)
   * @return boolean|void
   */
	var getMediaQuery = function( lower, upper ) {
		var query = 'screen';

		if ( !getBreakpoint( lower ) && !getBreakpoint( upper ) ) throw 'invalid breakpoint names: "' + lower + '", "' + upper + '"';
		if ( getBreakpoint( lower ) ) query += ' and (min-width: ' + getBreakpoint( lower ) + 'px)';
		if ( getBreakpoint( upper ) ) query += ' and (max-width: ' + ( getBreakpoint( upper ) - 1 ) + 'px)';

		return window.matchMedia( query );
	};

	/**
   * check if current screen matches breakpoints
   *
   * @param string lower – lower breakpoint name
   * @param string [upper] – upper breakpoint name (optional)
   * @return boolean|void
   */
	var matches = function( lower, upper ) {
		return getMediaQuery( lower, upper ).matches;
	};

	/**
   * add a watcher
   * callback will be executed whenever the status changes.
   *
   * @param function callback – the callback function (mq object as first argument)
   * @param string lower – lower breakpoint name
   * @param string [upper] – upper breakpoint name (optional)
   *
   * @example
   * EN.Media.watch(function(mq) {
   * 		if (mq.matches) {
   * 			console.log('changed to desktop')
   * 		}
   * 		else {
   * 			console.log('not desktop anymore')
   * 		}
   * }, 'desktop');
   */
	var watch = function( callback, lower, upper ) {
		var mq = getMediaQuery( lower, upper );
		return mq.addEventListener( 'change', callback );
	};

	// exports
	return {
		getBreakpoint: getBreakpoint,
		getMediaQuery: getMediaQuery,
		matches: matches,
		watch: watch
	};
} )();

export default MediaHelper;
